import React from 'react';
import '../styles/ProviderIcon.css';
import { GoogleDrive, Dropbox, OneDrive } from '../assets/icons';
import { getImageFolderProvider } from '../utils/imageUtils';
import { FaviconImg } from './SourceIcon';
import { hostFromUrl, faviconUrlForHost } from '../lib/sourceFaviconUtils';

// Renders the brand logo (Google Drive / Dropbox / OneDrive) for a cloud-storage
// URL. For any other URL it renders `fallback` — a generic glyph supplied by the
// caller (e.g. ExternalLink, Image). Brand logos carry their own colours, so the
// caller only needs to colour the fallback.
//
// faviconFallback: when set and no brand logo matches, render the URL host's
// favicon (FaviconImg, which itself falls back to a generic icon on load error)
// instead of the caller's `fallback`. Use for click-out links where the
// destination site's favicon is more recognizable than a generic glyph.

const PROVIDER_ICON = { drive: GoogleDrive, dropbox: Dropbox, oneDrive: OneDrive };

function ProviderIcon({ url, className, fallback = null, faviconFallback = false }) {
    const provider = getImageFolderProvider(url);
    const Logo = provider ? PROVIDER_ICON[provider] : null;
    if (!Logo) {
        if (faviconFallback) {
            const favicon = faviconUrlForHost(hostFromUrl(url));
            if (favicon) return <FaviconImg src={favicon} className={className} />;
        }
        return fallback;
    }
    return <Logo className={['provider-icon', className].filter(Boolean).join(' ')} />;
}

export default ProviderIcon;
